import React from "react";
import { SCROLL } from "@eave/shared/utils/dom";

export const useScrollLock = () => {
  // We're using a React Hook to lock the scroll when used and unlock it when it is removed.
  // But, we might have multiple scroll locks on the page at the same time, so we need to keep
  // track of how many there are so we don't accidentally unlock the scroll. To do this, we're
  // keeping a counter on this function itself (useScrollLocks.locks: number) instead of trying
  // to do something like juggle a counter Context.
  React.useEffect(() => {
    // When we start to use this, increment the counter
    useScrollLock.locks += 1;
    // Also, lock the scroll
    SCROLL.lock();

    return () => {
      // When this unmounts, decrement
      useScrollLock.locks -= 1;

      // If the count is already at 1 or lower, then unlock the scroll
      if (useScrollLock.locks < 1) {
        SCROLL.unlock();
      }
    };
  });
};

useScrollLock.locks = 0;

export const LockScroll = () => {
  useScrollLock();

  return null;
};

export default LockScroll;
